import { IApplyUniConfig } from 'api-paths-cas';

export enum ApplyConfigActionTypes {
  GET_APPLY_CONFIG = '@@apply-config/GET_APPLY_CONFIG',
  GET_APPLY_CONFIG_SUCCESS = '@@apply-config/GET_APPLY_CONFIG_SUCCESS',
  GET_APPLY_CONFIG_FAILURE = '@@apply-config/GET_APPLY_CONFIG_FAILURE',
}

export interface IApplyConfigState {
  readonly applyConfig: IApplyUniConfig;
  readonly applyConfigLoaded: boolean;
  readonly error: string | undefined;
}
